export const reviews = [
    {
        name: "Mariana G.",
        date: "Hace 2 meses",
        rating: 5,
        text: "Muy buen servicio y habitaciones limpias y cómodas.",
    },
    {
        name: "Jorge R.",
        date: "Hace 3 meses",
        rating: 5,
        text: "Es de los mejores hoteles en Punta Pérula, relación calidad-precio-comodidad es un 10.",
    },
    {
        name: "Alejandra M.",
        date: "Hace 4 meses",
        rating: 4,
        text: "A 2 cuadras de la playa, excelentes cuartos y con todos los servicios funcionando.",
    },
    {
        name: "Carlos T.",
        date: "Hace 5 meses",
        rating: 5,
        text: "Un lugar bonito, tranquilo, cerca de la playa y con un trato muy amable.",
    },
    {
        name: "Lucía P.",
        date: "Hace 6 meses",
        rating: 4,
        text: "El malecón y la playa están justo a una cuadra de distancia, eso me encantó.",
    },
];

export const averageRating = "4.5";
